<template>
  <div>
    <span class="NavigationQuickLinks-styles-quick-links-header">
      <h3 class="Navigation-styles-nav-section-title" v-html="(compact) ? t.quick : t.quick_links"></h3>
    </span>
    <router-link :to="{name: 'highlighted'}" class="NavigationAllMatches-styles-link" id="navigation-link-recommended">
      <img class="NavigationAllMatches-styles-icon" src="/static/assets/img/recommended.png" alt="Empfehlungen" width="20" height="20">
      <span class="NavigationAllMatches-styles-title">{{ t.highlighted }}</span>
    </router-link>
    <router-link class="NavigationAllMatches-styles-link" id="navigation-link-favorites" :to="{name: 'myFavorites'}">
      <img class="NavigationAllMatches-styles-icon" src="/static/assets/img/highlights.png" alt="My Favorites" loading="lazy" width="20" height="20">
      <span class="NavigationAllMatches-styles-title">{{ t.my_favorites }}</span>
    </router-link>
    <router-link :to="{name: 'today'}" class="NavigationAllMatches-styles-link NavigationQuickLinks-styles-today-link" id="navigation-link-todaysmatches">
      <img class="NavigationAllMatches-styles-icon" src="/static/assets/img/today.svg" alt="Spiele von heute" loading="lazy" width="20" height="20">
      <span class="NavigationAllMatches-styles-title">{{ t.today_matches }}</span>
      <div class="NavigationQuickLinks-styles-calendar-date">{{ today | moment('DD') }}</div>
    </router-link>
    <a :href="'/#/sportsbook?r=1575'" class="NavigationAllMatches-styles-link NavigationQuickLinks-styles-today-link" id="navigation-link-germany">
      <img  class="NavigationAllMatches-styles-icon" src="/static/assets/img/de.svg" alt="Deutscher Fußball" loading="lazy" width="20" height="20">
      <span class="NavigationAllMatches-styles-title">Deutscher Fußball</span>
    </a>
    <a :href="'/#/sportsbook?r=1718'" class="NavigationAllMatches-styles-link NavigationQuickLinks-styles-today-link" id="navigation-link-germany">
      <img class="NavigationAllMatches-styles-icon" src="/static/assets/img/tr.svg" alt="Deutscher Fußball" loading="lazy" width="20" height="20">
      <span class="NavigationAllMatches-styles-title">Türk Futbolu</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'quickLinks',
  data () {
    return {
      session: window.session,
      compact: false,
      t: this.$root.t,
      today: new Date().toISOString().slice(0, 10),
    }
  },
  mounted() {
    var th = this
    this.$bus.$on('compact', (payload) => {

      th.compact = payload;

    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/quickLinks.vue